import {OrderType} from '../../constants/orderTypes';

export const orderItems = (state = [], action) => {
  switch (action.type) {
    case 'ADD_TO_ORDER':
      return [...state, action.data];
    case 'UPDATE_ORDER_ITEM': {
      const selectedItem = action.data;
      const updatedState = state.map((item) => {
        if (item.guidCode === selectedItem.guidCode) {
          return Object.assign({}, selectedItem);
        }
        return item;
      });
      return [...updatedState];
    }
    case 'DELETE_ORDER_ITEM':
      return [...state.filter(i => i.guidCode !== action.data.guidCode)];
    case 'CLEAR_ORDER':
      return [];
    default:
      return state;
  }
};

export const orderType = (state = OrderType.ASAP, action) => {
  switch (action.type) {
    case 'SET_ORDER_TYPE':
      return action.data;
    default:
      return state;
  }
};

export const orderInfo = (state = {}, action) => {
  switch (action.type) {
    case 'SET_ORDER_INFO':
      return action.data;
    case 'CLEAR_ORDER':
      return {};
    default:
      return state;
  }
};

export const orderDateTime = (state = null, action) => {
  switch (action.type) {
    case 'SET_ORDER_DATE_TIME':
      return action.data;
    default:
      return state;
  }
};

export const currentOrderItem = (state = null, action) => {
  switch (action.type) {
    case 'SET_CURRENT_ORDER_ITEM':
      return action.data;
    case 'CANCEL_SELECTION':
      return null;
    default:
      return state;
  }
};
